module.exports = __webpack_public_path__ + "img/subtract.841df15e.svg";